var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var getDefaultSectionIndex = function (defaultSection, sections) {
    if (defaultSection) {
        var labels = sections.reduce(function (allLabels, section) { return __spreadArray(__spreadArray([], allLabels, true), [section.label], false); }, []);
        return labels.indexOf(defaultSection.label);
    }
    return 0;
};
export default {};
